import { Model } from '../__generated/configurator-builder.js'
import { implementCustomExpressions } from '../__generated/implementation.js'

export const baseFourLegCombinedExpressions = implementCustomExpressions({
  BaseFourLegCombined: {
    $width: s => s.$table.$top.$width - (s.$table.$top.edgeStyle === Model.EdgeStyles.Beveled ? 1 : 0),
    $widthScaleZero: s => s.$baseDataMap[s.type]?.sizing.width.scaleZero,
    $widthScaleOne: s => s.$baseDataMap[s.type]?.sizing.width.scaleOne,

    $beveledEdgeConsideration: s =>
      s.$table.$top.edgeStyle === Model.EdgeStyles.Beveled ? -(s.$table.$top.$bevelThickness * 2) : 0,

    $length: s => {
      let topLength = s.$table.$top.$length

      if (s.$table.$top.$leafCenterVisible) {
        topLength += s.$table.$top.$leafLength * s.$table.$top.leafAmount
      }
      return topLength + s.$beveledEdgeConsideration
    },
    $lengthScaleZero: s => s.$baseDataMap[s.type]?.sizing.length.scaleZero,
    $lengthScaleOne: s => s.$baseDataMap[s.type]?.sizing.length.scaleOne,
  },
})
